// ** Children
const initialState = {
  children: false
}

const children = (state = initialState, action) => {
  switch (action.type) {
    case "SET_CHILDREN_TYPES_CONTENT":
      return { ...state, children: action.val }
    default:
      return state
  }
}

export default children
